export default () => {
  let $filter_form = $('.partner-sales__filter__form');
  $('.partner-sales__filter__trigger').on('click', function(e){
      e.preventDefault();
      $filter_form.toggleClass('active');
  });

  $('input[name="filter_from"]').change(function() {
    $('input[name="filter_to"]').val($(this).val());
  });
}
